var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9566 8.15878C15.9566 7.61666 15.9117 7.0716 15.816 6.53827H8.13904V9.60933H12.5353C12.3529 10.5998 11.7667 11.476 10.9084 12.0328V14.0254H13.5312C15.0714 12.6364 15.9566 10.5852 15.9566 8.15878Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13912 15.9507C10.3343 15.9507 12.1855 15.2445 13.5343 14.0255L10.9115 12.0328C10.1817 12.5192 9.23968 12.7947 8.14211 12.7947C6.01874 12.7947 4.21837 11.391 3.57239 9.50385H0.865845V11.5581C2.24753 14.2511 5.06173 15.9507 8.13912 15.9507Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56935 9.50381C3.22841 8.51333 3.22841 7.44081 3.56935 6.45033V4.39612H0.865794C-0.288598 6.6496 -0.288598 9.30454 0.865794 11.558L3.56935 9.50381Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13912 3.15658C9.29949 3.139 10.421 3.56684 11.2614 4.35219L13.5851 2.07526C12.1137 0.721417 10.1608 -0.0229058 8.13912 0.000537432C5.06173 0.000537432 2.24753 1.70017 0.865845 4.39614L3.5694 6.45035C4.21239 4.56024 6.01575 3.15658 8.13912 3.15658Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle1);
export default __webpack_public_path__ + "static/media/google1.29d361ddcf0c3b8e3637fc4c26def596.svg";
export { ForwardRef as ReactComponent };